import BaseClient, { type BaseClientConfig, type ExtendedAxiosRequestConfig } from '../BaseClient';
import { axiosCacheInterceptorRequestConfig } from '~/services/analytics/analyticsClient.types';
import type {
    WorkflowAnalyticsClientInterface,
    WorkflowVersionParticipationParams,
} from './workflowAnalyticsClient.types';

export default class CorporateWorkflowAnalyticsClient extends BaseClient implements WorkflowAnalyticsClientInterface {
    constructor(private teamId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getWorkflowVersionParticipation(params: WorkflowVersionParticipationParams, config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/statistics/workflows/version-participation`;
        return this.makeCoreApiRequest(url, 'post', params, null, {
            ...axiosCacheInterceptorRequestConfig,
            ...config,
        });
    }
}
